import React from 'react';
import '../../containers/customers/customer/CustomerOverviewDetail.scss';
import { CustomTitleLabel } from '../earning/CustomBaseComponments';
import CustomRadios from '../base/CustomRadios';

function CustomInputWithTitle({
  title,
  customTitleClass,
  defaultValue,
  setValue,
  options,
  related = {},
}) {
  const relatedComponment = () => {
    // console.log('@@@20:', related);
    switch (related.type) {
      case 'input':
        // console.log('@@@20');
        return (
          <input
            type="text"
            onChange={({ target }) => {
              related.setValue(target.value);
            }}
            value={related.defaultValue}
            className={`custom-markdown-area-title custom-markdown-area-title-short`}
            onFocus={() => {}}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div style={{ display: 'grid' }}>
      <CustomTitleLabel title={title} className={customTitleClass} />
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <CustomRadios
          onChange={(value) => {
            // setRewardType(value);
            setValue(value);
          }}
          default={defaultValue}
          options={options}
        />
      </div>
      {relatedComponment()}
    </div>
  );
}

export default CustomInputWithTitle;
